import type { CSSProperties } from "react";

import type { LocaleCode } from "@/i18n/types";
import type { LocaleContent, SiteConfig, ThemeTokens } from "@/types/site";
import { siteConfigSchema } from "@/types/site";

export function createSiteConfig(rawConfig: unknown): SiteConfig {
  return siteConfigSchema.parse(rawConfig);
}

export function createThemeStyle(theme: ThemeTokens): CSSProperties {
  return {
    "--accent": theme.accent,
    "--background": theme.background,
    "--button-radius": theme.buttonRadius,
    "--font-body": theme.fontBody,
    "--font-display": theme.fontDisplay,
    "--foreground": theme.foreground,
    "--hero-glow": theme.heroGlow,
    "--primary": theme.primary,
    "--radius": theme.radius,
    "--section-spacing": theme.sectionSpacing,
    "--secondary": theme.secondary,
    "--shadow-strength": theme.shadowStrength,
    "--surface": theme.surface,
    "--surface-muted": theme.surfaceMuted,
    "--surface-strong": theme.surfaceStrong,
  } as CSSProperties;
}

export function getLocaleContent(
  config: SiteConfig,
  locale: LocaleCode,
): LocaleContent {
  const direct = config.locales[locale];
  if (direct) return direct;
  const fallbackLocale = config.shared.locales[0] as LocaleCode;
  const fallback = config.locales[fallbackLocale];
  if (!fallback) {
    throw new Error("siteConfig contains no localized content.");
  }
  return fallback;
}
